import { FormManagementStatus } from '@/api/enum/common.enum';
import { Chip } from '@mui/material';

interface Props {
	status: number | string | undefined;
	label: string;
	sx?: any;
}

export default function FormManagementChip({ status, label, sx }: Props) {
	return (
		<Chip
			sx={sx}
			color={
				status == FormManagementStatus.submitted
					? 'chipTertiary'
					: status == FormManagementStatus.uploaded
					? 'chipPrimary'
					: 'default'
			}
			label={label}
		/>
	);
}
